// Port of api/fuel/app/classes/filter/search/games/filters/query/config/nest.php
import F from 'offline/filter/constants'

export default {
	name: 'config.nest',
	priority: 2,
	_cache_require: [F.CACHE_COLLECTION],
	require: function(config, filter) {
		return !filter.nested && filter.expansions !== 2
	},
	run: function(config, filter, _data, query) {
		var isAuto = !!(((config.settings || {}).session || {}).collection || {}).nest

		if (config.ownerType === F.OWNER_USER) {
			if (filter.orphans && filter.orphans.length) {
				query.whereGroup('OR', [
					['AND', [
						['c.collection_nested', '<=', isAuto ? F.NESTED_NONE : F.NESTED_OFFICIAL]
					]],
					['AND', [
						['c.collection_id', 'in', filter.orphans]
					]]
				])
			} else {
				query.where('c.collection_nested', '<=', isAuto ? F.NESTED_NONE : F.NESTED_OFFICIAL)
			}
		} else {
			if (!isAuto) return

			if (filter.orphans && filter.orphans.length) {
				query.whereGroup('OR', [
					['AND', [
						['c.collection_expansion', '=', 0]
					]],
					['AND', [
						['c.game_id', 'in', filter.orphans]
					]]
				])
			} else {
				query.where('c.collection_expansion', '=', 0)
			}
		}
	}
}
